export default {
    twilio_received_a_delivery_receipt_indicating_that_the_outbound_message_was_not_delivered:
        'טוויליו דיווח  שההודעה לא נמסרה',
    twilio_has_received_information_of_outbound_message_failed_to_send:
        'טוויליו דיווח שההודעה לא נשלחה',
    server_error: 'שגיאת שרת',
    invalid_number_format: 'מספר בפורמט לא תקין',
    error_during_creating_meeting: 'שגיאה ביצירת פגישה. אנא נסה שוב מאוחר יותר...',
    meeting_has_been_added: 'הפגישה נוספה',
    something_went_wrong: 'משהו השתבש',
}
